module.exports = __webpack_public_path__ + "img/17-image-2@2x.a3881377.png";